module.exports = __webpack_public_path__ + "img/formulas_3.62fba0e4.svg";